import type { TaskStatus } from '../types/fulfillment'

export const STATUS_LABELS: Record<TaskStatus, string> = {
  new: 'Pendente',
  preparing: 'Em separação',
  shipped: 'Enviado',
  delivered: 'Entregue',
  cancelled: 'Cancelado',
}

export const STATUS_COLORS: Record<TaskStatus, { bg: string; text: string }> = {
  new: { bg: 'bg-amber-100', text: 'text-amber-800' },
  preparing: { bg: 'bg-blue-100', text: 'text-blue-800' },
  shipped: { bg: 'bg-indigo-100', text: 'text-indigo-800' },
  delivered: { bg: 'bg-green-100', text: 'text-green-800' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-800' },
}

export const VALID_TRANSITIONS: Record<TaskStatus, TaskStatus[]> = {
  new: ['preparing', 'cancelled'],
  preparing: ['shipped', 'cancelled'],
  shipped: ['delivered'],
  delivered: [],
  cancelled: [],
}

export function getStatusLabel(status: TaskStatus): string {
  return STATUS_LABELS[status] ?? status
}

export function getStatusColors(status: TaskStatus): { bg: string; text: string } {
  return STATUS_COLORS[status] ?? { bg: 'bg-gray-100', text: 'text-gray-800' }
}

export function getNextStatuses(current: TaskStatus): TaskStatus[] {
  return VALID_TRANSITIONS[current] ?? []
}

export function canTransition(from: TaskStatus, to: TaskStatus): boolean {
  return (VALID_TRANSITIONS[from] ?? []).includes(to)
}
